import { useEffect } from "react";
import { connect } from "react-redux";
import LiveTable from "./Table";
import { getListLiveCampaign } from "../../../../store/action/liveCampaignAction";
import Pagination from "../../../shared/components/Button/Pagination";

const _ = require('lodash');

const LiveCampaign = (props) => {
   const { getListLiveCampaign, page, total } = props;
   const onChangePaginate = (page, pageSize) => {
      getListLiveCampaign(page, pageSize);
   }

   return (
      <div className="list-campaign-wrapper">
         <div className="app-v2-table-container list-campaign-table">
            <div>
               <div>
                  <div className="app-table-container app-scrollbar has-column-fixed-right">
                     <LiveTable />
                  </div>
               </div>
               <div className="app-v2-table-footer-wrapper">
                  <div className="">
                     <Pagination
                        total={total}
                        onChange={onChangePaginate}
                     />
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { page, liveCampaign } = state;
   return {
      page,
      total: _.isInteger(liveCampaign.total) ? liveCampaign.total : 0,
   };
}

export default connect(mapStateToProps, {
   getListLiveCampaign
})(LiveCampaign);